import React, { useState, useEffect } from 'react'
import TrueFalseQuestion from '../quiz/TrueFalseQuestion'

const DSDirectTest: React.FC = () => {
  const [dsQuestion, setDsQuestion] = useState<any>(null)
  const [answers, setAnswers] = useState<Record<string, any>>({})

  useEffect(() => {
    // Tạo mock DS question với dữ liệu thực tế từ database
    const mockDSQuestion = {
      id: 'test-ds-question',
      type: 'dung_sai',
      question_lead: 'Một con lắc lò xo dao động điều hòa với phương trình x = 10cos(16πt - π/3) cm. Xét tính đúng, sai của các phát biểu sau:',
      statement_a: 'Biên độ dao động của con lắc là 10 cm',
      statement_b: 'Tần số góc của dao động là 16π rad/s', 
      statement_c: 'Pha ban đầu của dao động là -π/3 rad',
      statement_d: 'Chu kì dao động của con lắc là 1/8 s',
      answer_a: 'Đúng',
      answer_b: 'Đúng', 
      answer_c: 'Đúng',
      answer_d: 'Đúng',
      solution_a: 'Từ phương trình x = 10cos(16πt - π/3), biên độ A = 10 cm',
      solution_b: 'Từ phương trình, tần số góc ω = 16π rad/s',
      solution_c: 'Từ phương trình, pha ban đầu φ = -π/3 rad',
      solution_d: 'Chu kì T = 2π/ω = 2π/(16π) = 1/8 s',
      hinh_anh: null
    }

    console.log('🎯 Mock DS Question:', mockDSQuestion)
    setDsQuestion(mockDSQuestion)
  }, [])

  const handleAnswerChange = (questionId: string, answer: any) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answer
    }))
    console.log('📝 Answer changed:', { questionId, answer })
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">DS Direct Test</h1>
      <p className="text-gray-600 mb-6">
        Test trực tiếp TrueFalseQuestion với mock DS data
      </p>

      {dsQuestion && (
        <div className="space-y-6">
          <div className="bg-blue-50 p-4 rounded-lg">
            <h2 className="font-semibold mb-2">Expected Structure:</h2>
            <div className="text-sm space-y-1">
              <div><strong>1. Câu dẫn:</strong> {dsQuestion.question_lead}</div>
              <div><strong>2. Hình ảnh:</strong> {dsQuestion.hinh_anh || 'Không có'}</div>
              <div><strong>3. 4 phát biểu:</strong></div>
              <div className="ml-4 space-y-1">
                <div>A: {dsQuestion.statement_a}</div>
                <div>B: {dsQuestion.statement_b}</div>
                <div>C: {dsQuestion.statement_c}</div>
                <div>D: {dsQuestion.statement_d}</div>
              </div>
            </div>
          </div>

          <div className="border border-gray-300 rounded-lg p-6">
            <h2 className="text-lg font-semibold mb-4">TrueFalseQuestion Component:</h2>
            <TrueFalseQuestion
                      question={{
          ...dsQuestion,
          // Bỏ hoàn toàn cau_hoi, chỉ sử dụng question_lead từ database
          question_lead: dsQuestion.question_lead
        }}
              answers={answers}
              onAnswerChange={handleAnswerChange}
              showResults={false}
            />
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <h3 className="font-semibold mb-2">Current Answers:</h3>
            <pre className="text-sm">
              {JSON.stringify(answers, null, 2)}
            </pre>
          </div>
        </div>
      )}

      <div className="mt-6 bg-gray-50 p-4 rounded-lg">
        <h3 className="font-semibold mb-2">Debug Instructions:</h3>
        <div className="text-sm text-gray-600 space-y-1">
          <div>1. Mở Console để xem debug logs</div>
          <div>2. Kiểm tra xem có hiển thị đúng: Câu dẫn + 4 phát biểu riêng biệt</div>
          <div>3. Nếu vẫn sai, check logs để xem generateStatements() output</div>
        </div>
      </div>
    </div>
  )
}

export default DSDirectTest